(ns frontend.view.reports.components.side-menu
  (:require
   [common.localization :as loc]
   [frontend.routing :as routing]
   [reagent.core :as r]
   [frontend.bootstrap.components :as rbs]
   [frontend.state.current-session :as session]
   [frontend.utils :as fu]
   [frontend.tenant-customizations :as tenant-customizations]))

(defn nav-item
  [{:keys [view-key k icon label]}]
  (r/as-element
   [rbs/NavItem
    {:key        k
     :active     (= view-key k)
     :class-name (fu/cs (when (= view-key k) "active"))
     :href       (routing/path-for k)
     :on-click   (fn [e]
                   (.preventDefault e)
                   (routing/set-view! [k]))}
    [:i
     {:class-name  (str "fal " icon)
      :aria-hidden true}]
    [:span.hidden-xs.hidden-sm.left-side-menu__text
     (or label
         (->> k
              name
              (keyword "reports")
              loc/tr))]]))

(defn view
  [view-key]
  [rbs/Nav
   {:variant    "pills"
    :stacked    true
    :class-name "left-side-menu"}
   [rbs/NavItem
    {:role  "presentation"
     :class "left-side-menu__header hidden"}
    "Reports"]
   (when (or (session/sys-admin?)
             (session/zadmin?)
             (tenant-customizations/imec-xpand?))
     [rbs/NavItem
      {:active   false
       :key      :custom-reports-2
       :on-click (fn [e]
                   (.preventDefault e)
                   (routing/set-view! [:reports-printout
                                       :report "imecs"
                                       :token "preview"
                                       :start-date "0"
                                       :end-date "1"]))}
      [:i
       {:class-name  (str "fal " "fa-file-chart-pie")
        :aria-hidden true}]
      [:span.hidden-xs.hidden-sm.left-side-menu__text
       (loc/tr :quarterly-reports)]])
   (when (or (tenant-customizations/panostaja?)
             (tenant-customizations/knight-therapeutics?))
     [nav-item
      {:view-key view-key
       :k        :custom-reports
       :icon     "fa-pencil-ruler"
       :label    (loc/tr :reports/custom-reports [@session/tenant-name])}])

   ;;TODO remove this (and the whole side_menu.cljs?) when
   ;; testing :main-reports is finished
   [nav-item
    {:view-key view-key
     :k        :main-reports
     :icon     "fa-pencil-ruler"
     :label    "test - all"}]

   ;; TODO disabled for now
   #_[nav-item
      {:view-key view-key
       :k        :passed-deals
       :icon     "fa-ban"}]])
